import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Switch, Button, Space, message } from 'antd';
import axios from 'axios';

const { Title, Paragraph } = Typography;

const FacebookSettings = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get('/api/integrations/facebook');
        if (data) {
          form.setFieldsValue({
            app_id: data.app_id || '',
            app_secret: data.app_secret || '',
            access_token: data.access_token || '',
            business_manager_id: data.business_manager_id || '',
            live_mode: !!data.live_mode,
          });
        } else {
          form.setFieldsValue({ live_mode: false });
        }
      } catch (e) {
        message.error(e.response?.data?.error || 'Failed to load Facebook settings');
      }
    };
    load();
  }, [form]);

  const onSubmit = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      const values = form.getFieldsValue();
      const headers = {};
      const token = sessionStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;
      await axios.put('/api/integrations/facebook', values, { headers });
      message.success('Facebook settings saved');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.response?.data?.error || e.message || 'Failed to save Facebook settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Integrations' },
        { title: 'Facebook' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Facebook API Settings</Title>
        <Space>
          <Button type="primary" onClick={onSubmit} loading={saving}>Save Settings</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Configure Facebook Marketing API credentials. Replace placeholders with your backend integration endpoints.
        </Paragraph>
        <Form form={form} layout="vertical">
          <Form.Item label="App ID" name="app_id" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="App Secret" name="app_secret" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item label="Access Token" name="access_token">
            <Input.Password />
          </Form.Item>
          <Form.Item label="Business Manager ID" name="business_manager_id">
            <Input />
          </Form.Item>
          <Form.Item label="Live Mode" name="live_mode" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default FacebookSettings;
